import { ComponentType } from 'react';
import { Headphones } from 'lucide-react';
import sidebarImpact from '../../assets/images/sidebar/sidebar-impact.png';
import sidebarActivity from '../../assets/images/sidebar/sidebar-activity.png';
import sidebarSettings from '../../assets/images/sidebar/sidebar-settings.png';

export type IconType = ComponentType<{ className?: string; style?: React.CSSProperties }> | string;

export interface NavItem {
  id: string;
  path: string;
  icon: IconType;
  label: string;
  requiresContributor?: boolean;
  showBadge?: boolean;
  component?: ComponentType;
}

export const navigationConfig = {
  primary: [
    {
      id: 'impact',
      path: '/impact',
      icon: sidebarImpact,
      label: 'Impact',
      requiresContributor: false
    },
    {
      id: 'listening',
      path: '/listening-room',
      icon: Headphones,
      label: 'Listening Room',
      requiresContributor: true
    },
    {
      id: 'notifications',
      path: '/notifications',
      icon: sidebarActivity,
      label: 'Notifications',
      requiresContributor: true,
      showBadge: true
    }
  ] as NavItem[],

  secondary: [
    {
      id: 'settings',
      path: '/settings',
      icon: sidebarSettings,
      label: 'Settings',
      requiresContributor: false
    }
  ] as NavItem[]
};

export const ICON_STYLES = {
  // Standard gray color used by headphones icon
  interactive: '#73869E',
  // Hover and active states
  hover: '#8B9DC3',
  active: '#FFFFFF'
};